// extracted by mini-css-extract-plugin
module.exports = {"currency":"_ea5f230"};